import { useCallback } from "react";
import lsApi from "../api/lsApi";
import { INotificacion, IPublicacion } from '../models/publicaciones';
import { useAppSelector } from "../redux/hooks";

export function usePublicaciones() {
  const { userData } = useAppSelector(state => state.auth);

  const getPublicaciones = useCallback(async () => {

    try {
      let { data, status } = await lsApi.get<IPublicacion[]>('/api/ControlAcceso/ListadoPublicaciones')
      if (status === 200) {
        return data;
      }
      else {
        return [
          {
            correlativo: -1,
            fecha: 'Error! Status: ' + status,
            titulo: '',
            descripcion: ''
          }
        ]
      }
    }
    catch (error) {
      console.error(error);
      return [
        {
          correlativo: -1,
          fecha: 'Err',
          titulo: '',
          descripcion: ''
        }
      ]
    }
  }, []);

  const getPublicacionesPublicas = useCallback(async () => {

    try {
      let { data, status } = await lsApi.get<IPublicacion[]>('/api/ControlAcceso/ListadoPublicacionesPublicas')
      if (status === 200) {
        return data;
      }
      else {
        return [
          {
            correlativo: -1,
            fecha: 'Error! Status: ' + status,
            titulo: '',
            descripcion: ''
          }
        ]
      }
    }
    catch (error) {
      console.error(error);
      return [
        {
          correlativo: -1,
          fecha: 'Err',
          titulo: '',
          descripcion: ''
        }
      ]
    }
  }, []);

  const getNotificaciones = useCallback(async () => {

    try {
      let { data, status } = await lsApi.get<INotificacion[]>('/api/ControlAcceso/GetNotificaciones')
      if (status === 200) {
        return data;
      }
      else {
        return [
          {
            correlativo: -1,
            fecha: 'Error! Status: ' + status,
            estado: 1,
            texto: 'No se pudieron cargar las notificaciones'
          }
        ]
      }
    }
    catch (error) {
      console.error(error);
      return [
        {
          correlativo: -1,
          fecha: 'Err',
          estado: 1,
          texto: 'Error cargando notificaciones'
        }
      ]
    }
  }, []);

  const marcarNotificacionLeida = useCallback(async (correlativo: number) => {
    try {
      await lsApi.put(`/api/ControlAcceso/ActualizarLecturaNotificacion`, {
        Correlativo: correlativo,

      });
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  }, [userData]);

  const marcarTodasLeidas = useCallback(async () => {
    try {
      await lsApi.put(`/api/ControlAcceso/MarcarTodasLeidas`, {
        casa: userData?.casa,
        empresa: userData?.empresa
      });
    } catch (error) {
      console.error("Error marking all notifications as read:", error);
    }
  }, []);

  return {
    getPublicaciones,
    getNotificaciones,
    getPublicacionesPublicas,
    marcarNotificacionLeida,
    marcarTodasLeidas,
  }
}